<div #main class="main">
    <h3>{{ getOsmObjectName() }}</h3>
    <mat-divider></mat-divider>
    <h5>({{ getOsmObjectType() }})</h5>
</div>